/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';
    import ISystemConfig = Models.ISystemConfig;
    import SystemConfigKeys = Models.SystemConfigKeys;


    export interface IFlexService {
        name: string;
        status: string[];
        node: string;
        containerNames: string[];
    }

    interface IServiceStati {
        [key: string]: IServiceStatus[];
    }

    interface IServiceStatus {
        node: string;
        statusName: string;
        containerName: string;
    }


    interface IStartResult {
        started: boolean;
    }

    interface IStopResult {
        stopped: boolean;
    }

    interface IRemoveResult {
        success: boolean;
        wrongNode: boolean;
        error: string;
    }

    export class FlexWatchdogService {
        public static $name: string = "flexWatchdogService";
        public static $inject: string[] = ['$q', 'backendService'];

        public static statusColors: string[] = [
            '#ff001d', // red
            '#fefe47', // yellow
            '#bcff45', // green-yellow
        ];

        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = 'flexwatchdog/';
        private servicesRestPath: string = this.servicePath + 'services/';
        private containersRestPath: string = this.servicePath + 'containers/';
        private stopPathSuffix: string = '/stop';
        private startPathSuffix: string = '/start';
        private removePathSuffix: string = '/remove';


        constructor(private $q: ng.IQService, private backendService: Services.BackendService) {
            
        }

        public listServices(): ng.IPromise<IFlexService[]> {
            let url: string = this.backendBaseUrl + this.servicesRestPath;
            return this.backendService.get(url).then((result: ng.IHttpPromiseCallbackArg<IServiceStati>) => {
                let node: string;
                return Object.keys(result.data).map((serviceName: string) => {
                    const serviceStatuses: IServiceStatus[] = result.data[serviceName];
                    if (serviceStatuses && serviceStatuses.length > 0) {
                        node = serviceStatuses[0].node;
                        return {
                            name: serviceName,
                            status: serviceStatuses.map(iss => iss.statusName),
                            node: node,
                            containerNames: serviceStatuses.map(iss => iss.containerName),
                        } as IFlexService;
                    } else {
                        return {
                            name: serviceName,
                            status: [],
                            node: node,
                        } as IFlexService;
                    }
                });
            });
        }

        public startService(serviceName: string): ng.IPromise<boolean> {
            let url: string = this.backendBaseUrl + this.servicesRestPath + serviceName + this.startPathSuffix;
            return this.backendService.post(url, {}).then((result: ng.IHttpPromiseCallbackArg<IStartResult>) => {
                return result.data.started;
            });
        }

        public stopService(serviceName: string): ng.IPromise<boolean> {
            let url: string = this.backendBaseUrl + this.servicesRestPath + serviceName + this.stopPathSuffix;
            return this.backendService.post(url, {}).then((result: ng.IHttpPromiseCallbackArg<IStopResult>) => {
                return result.data.stopped;
            });
        }

        public getStatusColor(status: string): string {
            let level: number = 0;
            if (status === 'running')
                level = 2;
            else if (status === 'paused')
                level = 1;
            return FlexWatchdogService.statusColors[level];
        }

        public removeContainer(containerName: string, node: string): ng.IPromise<boolean> {
            let url: string = this.backendBaseUrl
                + this.containersRestPath + containerName + this.removePathSuffix
                + "?node=" + node;
            return this.backendService.post(url, {}).then((result: ng.IHttpPromiseCallbackArg<IRemoveResult>) => {
                if (result.data.wrongNode)
                    return this.removeContainer(containerName, node);
                else
                    return result.data.success;
            });
        }
    }
}
